var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as App from '../../app';
import * as SDK from '../../lib/sdk';
import bridge from '@vkontakte/vk-bridge';
import { BlueButton } from '../../lib/components/Button/Button';
import { throttle } from '../../lib/utils';
import { PHRASES, t } from '../../translate';
import { StoreProduct } from './StoreProduct';
import { coinsById } from '../../../backend/src/utils/coinsById';
import { CustomModal } from '../CustomModal';
import { priceById } from '../../../backend/src/utils/priceById';
import { RewardedButton } from '../../components/RewardedButton/RewardedButton';
import './StoreModal.less';
var name = 'StoreModal';
var StoreModal = /** @class */ (function (_super) {
    __extends(StoreModal, _super);
    function StoreModal(props) {
        var _this = _super.call(this, props, "".concat(name, " Modal_flex Modal_blue")) || this;
        _this.name = name;
        _this.maxBodyHeight = 380;
        _this.minBodyHeight = 200;
        _this.deltaBodyHeight = 170;
        _this.catalogPromise = null;
        _this.onBuy = null;
        _this.draw = throttle(function () {
            _super.prototype.draw.call(_this);
            if (_this.catalogPromise && _this.isVisible()) {
                _this.reloadCatalog();
            }
        }, 600);
        _this.toggleLoading = function (t) { return _this.toggleClassName('&_loading', t); };
        _this.toggleError = function (t) { return _this.toggleClassName('&_error', t); };
        return _this;
    }
    StoreModal.prototype.show = function (onBuy) {
        _super.prototype.show.call(this);
        this.onBuy = onBuy;
        this.toggleClassName('&_rvError', false);
        App.stat.params({ store: { open: 1 } });
        this.reloadCatalog();
    };
    StoreModal.prototype.close = function (data) {
        _super.prototype.close.call(this, data);
        this.onBuy = null;
        App.stat.params({ store: { close: 1 } });
    };
    StoreModal.prototype.getContent = function () {
        var _this = this;
        var header = this.DIV('&__header', [t(PHRASES.Store)]);
        return [
            header,
            (this.body = this.DIV('scrollbar', [
                this.DIV('Loading'),
                this.DIV('&__error', [t(PHRASES.Something_went_wrong)]),
                new BlueButton({ className: this.parseClassName('&__repeatBtn'), onClick: function () { return _this.reloadCatalog(true); } }, [
                    t(PHRASES.Try_again),
                ]),
                (this.catalog = this.DIV('&__catalog', [])),
                new RewardedButton({ onRewarded: function () { return _this.close(); } }),
            ])),
        ];
    };
    StoreModal.prototype.reloadCatalog = function (force) {
        var _this = this;
        this.toggleLoading(true);
        this.toggleError(false);
        this.getCatalog(force)
            .then(function (data) {
            _this.toggleLoading(false);
            _this.catalog.removeAllChild();
            data.forEach(function (p, index) {
                _this.catalog.appendChild(_this.DIV('&__catalog-item', [new StoreProduct({ p: p, onBuy: function () { return _this.onClickBuy(p); } })]), index === 0);
            });
        })
            .catch(function () {
            _this.toggleLoading(false);
            _this.toggleError(true);
        });
    };
    StoreModal.prototype.getCatalog = function (force) {
        if (!this.catalogPromise || force) {
            this.catalogPromise = SDK.Purchases.catalog();
        }
        return this.catalogPromise;
    };
    StoreModal.prototype.onClickBuy = function (p) {
        return __awaiter(this, void 0, void 0, function () {
            var coins, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        App.sounds.click();
                        App.stat.params({ purchases: { open: 1 } });
                        return [4 /*yield*/, this.buy(p)];
                    case 1:
                        if (_a.sent()) {
                            coins = coinsById(p.id, FOR_VK, FOR_YANDEX);
                            this.onBuy && this.onBuy(coins);
                            App.stat.params({ purchases: { consume: 1, price: priceById(p.id) } });
                            this.close(coins);
                            this.draw();
                        }
                        else {
                            this.close(0);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        App.stat.params({ purchases: { error: 1 } });
                        App.stat.error(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    StoreModal.prototype.buy = function (p) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (FOR_YANDEX) {
                    return [2 /*return*/, this.yandexBuy(p)];
                }
                else if (FOR_VK) {
                    return [2 /*return*/, this.vkBuy(p)];
                }
                else {
                    return [2 /*return*/, Promise.resolve(false)];
                }
                return [2 /*return*/];
            });
        });
    };
    StoreModal.prototype.vkBuy = function (p) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!FOR_VK) return [3 /*break*/, 2];
                        return [4 /*yield*/, bridge.send('VKWebAppShowOrderBox', { type: 'item', item: p.id })
                            // console.log('VKWebAppShowOrderBox', result) // {success: true, order_id: '1986665'}
                        ];
                    case 1:
                        result = _a.sent();
                        // console.log('VKWebAppShowOrderBox', result) // {success: true, order_id: '1986665'}
                        if (result.success) {
                            // incPurchaseCounter()
                            App.stat.params({ store: { purchase: 1 } });
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, false];
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    StoreModal.prototype.yandexBuy = function (p) {
        return __awaiter(this, void 0, void 0, function () {
            var purchase, coins, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!FOR_YANDEX) return [3 /*break*/, 7];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, SDK.Purchases.purchase(p)];
                    case 2:
                        purchase = _a.sent();
                        console.log({ purchase: purchase });
                        if (!purchase.signature) return [3 /*break*/, 4];
                        return [4 /*yield*/, App.Fn.consumeSignedPurchases(purchase.signature)];
                    case 3:
                        _a.sent();
                        coins = App.storage.get().coins;
                        App.Fn.waitBalance(coins).then(function (balance) { return App.Fn.updateCoins(balance); });
                        return [3 /*break*/, 4];
                    case 4:
                        App.Fn.updPurchaseTime();
                        return [3 /*break*/, 6];
                    case 5:
                        err_2 = _a.sent();
                        App.stat.error(err_2);
                        return [2 /*return*/, false];
                    case 6: return [2 /*return*/, true];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    return StoreModal;
}(CustomModal));
export { StoreModal };
